import { Component, Input, OnChanges } from '@angular/core';
import { TabData } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';

import { DynamicCharacteristicsInfoBubbles, DynamicCharacteristicsTableHeadings } from '../../config/risk.constants';

@Component({
	selector: 'risk-characteristics-table',
	templateUrl: './characteristics-table.component.html'
})
export class CharacteristicsTableComponent implements OnChanges {
	@Input() public tab: TabData;
	@Input() public asOfDateSNP: string;
	@Input() public customBenchmark?: string;

	public formatterTemplates: string[];
	public benchmarkTemplateFormatter: Function;

	public ngOnChanges(): void {
		this.formatterTemplates = [...Object.values(DynamicCharacteristicsTableHeadings), ...Object.values(DynamicCharacteristicsInfoBubbles)];
		this.benchmarkTemplateFormatter = StringUtil.getCustomBenchmarkFormatter();
	}
}

